<template>
  <header class="header">
    <!-- hamburger menu on sm screens -->
    <div class="text-gray-700 lg:hidden" @click="openNav">
      <VSvgIcon name="menu" width="40" height="40" class="inline-block h-full" />
    </div>

    <div class="header-logo">
      <router-link to="/">
        <img src="../assets/logo-color.svg" alt="ricoma logo" class="w-full" />
      </router-link>
    </div>

    <div class="flex items-center h-full pl-4">
      <!-- admin lang selelect -->
      <LanguageSelect
        v-if="isAdmin"
        :classes="{ container: 'w-32 h-12 text-sm border-b-2 rounded-t border-ricoma-orange-100' }"
      />

      <div v-if="!isAdmin" class="hidden p-3">
        <a href="https://ricoma.com/pages/lendio-financing" target="_blank block" class="">
          <div
            class="flex justify-around gap-4 items-center rounded-lg p-1"
            style="background: linear-gradient(180deg, #222937 0%, #12161e 100%)"
          >
            <div class="">
              <img src="../assets/Lendio-Ad-2.png" alt="lendio ad" class="w-24 h-auto" />
            </div>
            <div class="">
              <p class="text-xs text-white font-bold">Ready to Invest in Your Business?</p>
              <p style="font-size: 9px">
                <span class="text-orange-500"
                  >If you're serious about growing your apparel decoration business, financing your
                  equipment through Ricoma just got easier.</span
                >
              </p>
              <p style="font-size: 8px">
                <span class="text-white"
                  >We’ve partnered with <b>Lendio</b>, a trusted financing platform that connects
                  you with a network of lenders tailored to your specific needs.</span
                >
              </p>
            </div>
            <div class="">
              <img src="../assets/Lendio-Ad-button.png" alt="lendio ad" class="w-40 h-auto" />
            </div>
          </div>
          <!-- <img src="../assets/Lendio-Ad.png" alt="lendio ad" class="max-w-full" /> -->
        </a>
      </div>
      <div v-if="!isAdmin" class="header-pipe"></div>

      <!-- customer tech support -->
      <div v-if="!isAdmin" class="hidden md:block">
        <a href="https://support.ricoma.com/hc/en-us" target="_blank">{{ $t('header.support') }}</a>
      </div>

      <!-- pipe divider -->
      <div class="header-pipe"></div>

      <!-- contact us -->
      <div v-if="!isAdmin" class="hidden md:block">
        <a href="https://ricoma.com/pages/contact-us" target="_blank">{{ $t('header.contact') }}</a>
      </div>

      <div
        v-if="false && !isAdmin && giftcards && Array.isArray(giftcards) && giftcards.length"
        class="header-pipe"
      ></div>

      <div
        v-if="false && !isAdmin && giftcards && Array.isArray(giftcards) && giftcards.length"
        class="hidden md:block"
      >
        <div class="flex gap-2 items-center">
          <div class="text-3xl font-bold">
            ${{ giftcards.reduce((acc, cur) => acc + parseInt(cur.balance), 0) }}
          </div>
          <div>
            <p class="text-xs font-bold mb-0">
              Gift Card Balance<br />
              <a href="/giftcards" target="_blank" class="text-xs" style="color: #f17d21"
                >view details</a
              >
            </p>
          </div>
        </div>
      </div>

      <!-- pipe divider -->
      <div class="header-pipe hidden"></div>

      <div v-if="!isAdmin" class="hidden">
        <a href="https://www.facebook.com/groups/ricomausersofficial" target="_blank"
          ><img src="../assets/facebook-group.svg" alt="ricoma logo" class="w-full" />
        </a>
      </div>

      <!-- pipe divider -->
      <div class="header-pipe"></div>

      <!-- notifications dialog - ( this can be extacted into its own component when once we fully implement notifications ) -->
      <div v-if="!isAdmin" ref="notificationPreview" class="header-notifications">
        <div
          class="header-notifications-bell"
          @click="showNotificationDialog = !showNotificationDialog"
        >
          <VSvgIcon name="bell" />
          <div
            class="header-notifications-bell-outer"
            :class="[hasNotification ? 'block' : 'hidden']"
          >
            <div class="header-notifications-bell-inner"></div>
          </div>
        </div>

        <div
          class="z-40 header-notifications-dialog"
          :class="[showNotificationDialog && 'opacity-100 scale-100']"
        >
          <header class="header-notifications-dialog-header">
            <h3 class="header-notifications-dialog-header-heading">
              {{ $t('header.dialogs.notification.heading') }}
            </h3>
            <span
              class="header-notifications-dialog-header-action"
              :class="[hasNotification ? 'block' : 'hidden']"
              @click="() => handleNotifications(getIds(notifications))"
            >
              {{ $t('header.dialogs.notification.action') }}
            </span>
          </header>
          <div class="header-notifications-dialog-content">
            <ul>
              <li
                v-for="(n, index) in notifications"
                :key="`notification-${index}`"
                class="py-2"
                :class="[index !== notifications.length - 1 && 'border-b border-ricoma-gray-200']"
              >
                <div class="flex items-center justify-between">
                  <h4 class="font-semibold">{{ n.title }}</h4>
                  <span
                    class="header-notifications-dialog-header-action text-xxs"
                    @click="() => handleNotifications([n.id])"
                  >
                    Mark as read
                  </span>
                </div>
                <p>{{ n.content }}</p>
                <div>
                  <router-link
                    v-if="!n.is_external"
                    :to="n.link_url"
                    class="header-notifications-dialog-link"
                  >
                    {{ n.link_text }}
                    <VSvgIcon name="arrow-right" class="ml-1" />
                  </router-link>
                  <a
                    v-else
                    class="header-notifications-dialog-link"
                    :href="n.link_url"
                    target="_blank"
                  >
                    {{ n.link_text }}
                    <VSvgIcon name="arrow-right" class="ml-1" />
                  </a>
                </div>
              </li>
              <li v-if="!hasNotification" class="header-notifications-dialog-empty">
                {{ $t('header.dialogs.notification.empty') }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- user dialog -->
      <div class="header-user">
        <div class="flex items-center" ref="userPreview" @click="showUserDialog = !showUserDialog">
          <div class="header-user-initials">{{ initials }}</div>
          <div class="hidden md:block">{{ username }}</div>
          <div class="text-ricoma-gray-300">
            <VSvgIcon name="menu-down" class="w-8 h-8" />
          </div>
        </div>
        <div class="z-40 header-user-dialog" :class="[showUserDialog && 'open']">
          <router-link
            class="header-user-dialog-link"
            :to="!isAdmin ? '/account' : '/admin/account'"
          >
            {{ $t('header.dialogs.user.settings') }}
          </router-link>
          <router-link class="border-b-0 header-user-dialog-link" to="/auth/logout">
            {{ $t('header.dialogs.user.logout') }}
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import VSvgIcon from '@/components/base/VSvgIcon';
import LanguageSelect from '@/components/shared/LanguageSelect';

import { safeNullDataset } from '@/utils';

export default {
  name: 'Header',
  components: { VSvgIcon, LanguageSelect },
  props: {
    isAdmin: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showUserDialog: false,
      showNotificationDialog: false,
    };
  },
  computed: mapState({
    giftcards: state => safeNullDataset(state)(['customer', 'giftcards']),
    notifications: state => safeNullDataset(state)(['customer', 'notifications']),
    isNavOpen: state => state.isNavOpen,
    username() {
      return this.$user && this.fallbackUsername(this.$user);
    },
    initials() {
      return this.$user && this.fallbackInitials(this.$user);
    },
    hasNotification() {
      return !!this.notifications.length;
    },
  }),
  watch: {
    $route() {
      if (this.showUserDialog) this.showUserDialog = false;
      if (this.showNotificationDialog) this.showNotificationDialog = false;
    },
  },
  methods: {
    getIds(arr) {
      return arr.map(e => e.id);
    },
    handleNotifications(ids) {
      this.$store.dispatch('customer/removeNotifications', ids);
    },
    fallbackUsername({ first_name, last_name, email }) {
      return first_name && last_name
        ? `${first_name} ${last_name}`
        : first_name
        ? first_name
        : last_name
        ? last_name
        : email;
    },
    fallbackInitials({ first_name, last_name, email }) {
      return first_name && last_name
        ? `${first_name.charAt(0).toUpperCase()}${last_name.charAt(0).toUpperCase()}`
        : first_name
        ? first_name.charAt(0).toUpperCase()
        : last_name
        ? last_name.charAt(0).toUpperCase()
        : email.charAt(0).toUpperCase();
    },
    openNav() {
      this.$store.commit('openMobileNav');
    },
    // async handleNotification() {
    //   await this.$store.dispatch('auth/updateCustomerAccount', { seen_training_alert: true });
    // },
    handleEscape(e) {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.showUserDialog = this.showUserDialog && false;
        this.showNotificationDialog = this.showNotificationDialog && false;
      }
    },
    handleClickOutside(e) {
      const element1 = this.$refs.userPreview;
      if (!(element1 === e.target || element1.contains(e.target))) {
        this.showUserDialog && (this.showUserDialog = false);
      }

      // the notification element is only available in the customer side
      if (!this.isAdmin) {
        const element2 = this.$refs.notificationPreview;
        if (!(element2 === e.target || element2.contains(e.target))) {
          this.showNotificationDialog && (this.showNotificationDialog = false);
        }
      }
    },
  },
  async mounted() {
    document.addEventListener('keydown', this.handleEscape);
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEscape);
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
